import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles';
import { CircleCheckIcon } from '@lean-body/components/atoms';
export const GoalMatchingAssessmentResultAdvice = ({ classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.title) },
            "\u76EE\u6A19\u3092\u9054\u6210\u3059\u308B\u306B\u306F",
            React.createElement("span", { className: css(styles.titleBold) }, "\u300C\u5927\u304D\u304F\u59CB\u3081\u308B\u3088\u308A\u3001\u5C0F\u3055\u304F\u7D9A\u3051\u308B\u3053\u3068\u300D"),
            "\u304C\u5927\u5207\u3067\u3059\uFF01"),
        React.createElement("img", { src: "assets/images/goal_matching_assessments/result_advice.png", className: css(styles.mainImg) }),
        React.createElement("div", { className: css(styles.listLabel) }, "\u4F8B\u3048\u3070\u2026"),
        React.createElement("ul", { className: css(styles.list) },
            React.createElement("li", { className: css(styles.listItem) },
                React.createElement(CircleCheckIcon, { classObject: styles.listItemIcon, filled: true, fillColor: Colors.White, color: Colors.ProgressGreen }),
                "\u75B2\u308C\u3066\u3044\u308B\u304B\u3089",
                React.createElement("span", { className: css(styles.bold) }, "\u30B9\u30C8\u30EC\u30C3\u30C13\u5206")),
            React.createElement("li", { className: css(styles.listItem) },
                React.createElement(CircleCheckIcon, { classObject: styles.listItemIcon, filled: true, fillColor: Colors.White, color: Colors.ProgressGreen }),
                "\u30EC\u30C3\u30B9\u30F3\u305B\u305A\u306B",
                React.createElement("span", { className: css(styles.bold) }, "\u201C\u98DF\u4E8B\u8A18\u9332\u3060\u3051\u201C")),
            React.createElement("li", { className: css(styles.listItem) },
                React.createElement(CircleCheckIcon, { classObject: styles.listItemIcon, filled: true, fillColor: Colors.White, color: Colors.ProgressGreen }),
                React.createElement("span", { className: css(styles.bold) }, "500\u6B69\u3060\u3051"),
                "\u591A\u304F\u6B69\u3044\u3066\u307F\u308B")),
        React.createElement("div", { className: css(styles.desc) },
            React.createElement("b", { className: css(styles.bold) }, "\u300C\u3048\u3001\u305D\u308C\u3060\u3051\uFF1F\u300D\u3068\u601D\u3046\u304F\u3089\u3044\u3067OK\uFF01\uD83D\uDE0C"),
            React.createElement("br", null),
            "\u5C0F\u3055\u306A\u7A4D\u307F\u91CD\u306D\u304C\u3001\u8EAB\u4F53\u3068\u5FC3\u3092\u5909\u3048\u3066\u3044\u304D\u307E\u3059\uD83C\uDF31")));
};
const styles = StyleSheet.create({
    container: {},
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 1.28,
        margin: '0 auto',
        textAlign: 'center',
    },
    titleBold: {
        color: Colors.Accent,
    },
    mainImg: {
        display: 'block',
        width: '100%',
    },
    desc: {
        fontSize: 16,
        lineHeight: '140%',
        letterSpacing: 1.28,
    },
    bold: {
        fontWeight: 'bold',
    },
    list: {
        background: Colors.PrimaryTransparentB,
        borderRadius: '0 14px 14px 14px',
        padding: '12px 14px',
        marginBottom: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    listLabel: {
        display: 'inline-block',
        color: Colors.White,
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: '100%',
        letterSpacing: 0.96,
        padding: '6px 14px',
        borderRadius: '14px 14px 0 0',
        background: Colors.PrimaryDark,
    },
    listItem: {
        fontSize: 15,
        lineHeight: '140%',
        letterSpacing: 1.2,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    listItemIcon: {
        width: 18,
        height: 18,
        border: `0.5px solid ${Colors.White}`,
        borderRadius: 30,
    },
});
